// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';
import {debounce} from 'ts-debounce';
import _ from 'underscore';

import BenchlingConfig from 'BenchlingConfig';
import {isValidBase, isValidMixedBaseSequence} from 'biojs/Util';
import {Sequence} from 'components/Sequence';
import * as MapsConstants from 'constants/MapsConstants';
import {isFullUTFlexibilityEnabled} from 'modbio/util';
import CRISPRAnalysisStore from 'molbio/crispr/CRISPRAnalysisStore';
import CRISPRAnalysisTabState from 'molbio/crispr/CRISPRAnalysisTabState';
import CutSite from 'molbio/enzymes/backbone/CutSite';
import CutsiteMap from 'molbio/maps/linear/CutsiteMap';
import {InfiniteScroller} from 'molbio/maps/linear/InfiniteScroller';
import PolymerLinearMapView from 'molbio/maps/linear/PolymerLinearMapView';
import PolymerSliceItemSource, {
  PolymerSliceItemSourceAttributes,
} from 'molbio/maps/linear/PolymerSliceItemSource';
import Slice from 'molbio/maps/linear/Slice';
import Slices from 'molbio/maps/linear/Slices';
import {SliceView} from 'molbio/maps/linear/SliceView';
import {PolymerLinearMapState} from 'molbio/maps/MapStates';
import SequenceMapUtil, {ShowInputBubbleOptions} from 'molbio/maps/SequenceMapUtil';
import Type from 'molbio/maps/Type';
import {trackSequenceMapTabView} from 'molbio/SequenceAnalyticsHelper';
import * as sequtil from 'molbio/SeqUtil';
import SinglePolymerMapTabState from 'molbio/tabstates/SinglePolymerMapTabState';

type SequenceMapTabState = SinglePolymerMapTabState<Sequence, PolymerLinearMapState<Sequence>>;
class SequenceLinearMap extends PolymerLinearMapView<
  Sequence,
  PolymerLinearMapState<Sequence>,
  SequenceMapTabState
> {
  sliceSource!: SliceItemSource;
  infiniteScroller!: InfiniteScroller<SliceView>;
  analysisId?: string | null;
  debouncedUpdateCutsiteData!: () => void;

  static initClass(): void {
    this.prototype.id = 'linear-map';
    this.prototype.inputSource = 'linear-input';
  }

  initialize(options: Backbone.ViewOptions<SequenceMapTabState>): void {
    this._onAnalysisUpdate = this._onAnalysisUpdate.bind(this);
    super.initialize(options);
    this._setAnalysis(null);
    this._listenToAnalysis();
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.debouncedUpdateCutsiteData = debounce(this.updateCutsiteData, 1);
    this.updateCutsiteData();
    trackSequenceMapTabView(this.mapstate.get('sequence'), this.model.get('title'));
  }

  getType(): Type {
    return this.mapstate.get('layout')!.DNA.get('type');
  }
  storeRegionInBenchlingClipboard(e: JQueryEventObject): string {
    return SequenceMapUtil.maybeStoreNucleotideRegionInBenchlingClipboard(
      this.mapstate.get('sequence').selection(),
      e
    )!;
  }

  handlePasteText(text: string): void {
    SequenceMapUtil.handlePasteText(this.mapstate.get('sequence'), text);
  }

  handleCtrlShiftC(e: JQueryEventObject): void {
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return SequenceMapUtil.handleCtrlShiftC(this.mapstate.get('sequence'), e);
  }

  addPolymersForSearch(): void {
    SequenceMapUtil.addPolymersForSearch(this.model.get('sequence'));
  }

  removePolymersForSearch(): void {
    SequenceMapUtil.removePolymersForSearch(this.model.get('sequence'));
  }

  stopListening(): void {
    // FIXME: this is ugly shit.
    if (arguments.length === 0) {
      super.stopListening();
      $(window).off('.linear');
      this.$el.off('.linear');
      // eslint-disable-next-line @typescript-eslint/unbound-method
      CRISPRAnalysisStore.removeChangeListener(this._onAnalysisUpdate);
    } else {
      // eslint-disable-next-line prefer-rest-params
      super.stopListening(...arguments);
    }
  }

  _setAnalysis(analysisId: string | null): void {
    this.analysisId = analysisId;
    this._onAnalysisUpdate();
  }

  _listenToAnalysis(): void {
    // Find an analysis to listen to if there is an active one
    const fileState = this.mapstate.get('sequence').fileState();
    const activeTab = fileState.findTab(CRISPRAnalysisTabState, (tab) => tab.get('active'));
    if (activeTab == null) {
      const existingTab = fileState.findTab(
        CRISPRAnalysisTabState,
        (tab) => tab.analysisId() === this.analysisId
      );
      if (existingTab != null) {
        return;
      }
      this._setAnalysis(null);
      return;
    }
    const analysisId = activeTab.analysisId();
    if (this.analysisId === analysisId) {
      return;
    }
    this._setAnalysis(analysisId);
  }

  _onAnalysisUpdate(): void {
    const {analyses} = CRISPRAnalysisStore.getState();
    const analysis = analyses[this.analysisId!] != null ? analyses[this.analysisId!] : null;
    if (analysis == null) {
      this.analysisId = null;
    }
    // @ts-expect-error: not sure what the correct type is here (CRISPRAnalysisSummary vs something else)
    this.mapstate.get('layout').PAMSites.set({analysis});
  }

  registerListeners(): void {
    super.registerListeners();

    // Listen for analysis changes
    const fileState = this.mapstate.get('sequence').fileState();
    fileState.buffers().forEach((buffer) => {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.listenTo(buffer.tabs(), 'add remove reset change:active', this._listenToAnalysis);
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    CRISPRAnalysisStore.addChangeListener(this._onAnalysisUpdate);
    const cutsites = this.mapstate.get('sequence').get('cutsites');
    CutsiteMap.addListeners(this, cutsites, this.debouncedUpdateCutsiteData);
  }

  updateCutsiteData(): void {
    const slices = this.makeSlicesForCutsites();
    sequtil.setCutsiteData(this.mapstate.get('sequence'), slices, this.maxBases());

    // Copy cutsite data from cutsiteSlice into real slice.
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const i in this.infiniteScroller.indexMap) {
      const item = this.infiniteScroller.indexMap[i];
      const {slice} = item.item();
      const cutData =
        this.sliceSource.cutsiteSlices[i] != null
          ? this.sliceSource.cutsiteSlices[i].get('cutData')
          : undefined;
      if (cutData != null) {
        slice.set('cutData', cutData);
      }
    }
  }

  createSliceItemSource(args: {
    mapstate: PolymerLinearMapState<Sequence>;
    tabstate: SequenceMapTabState;
    $linear: JQuery;
    cutsiteSlices: Slices;
  }): SliceItemSource {
    return new SliceItemSource(args);
  }

  makeSlicesForCutsites(): {[index: number]: Slice} {
    // Cutsites have updated as a result of the sequence changing,
    // so we need to recreate the cutsite slices before they get set.
    this.sliceSource.makeSlices();
    return this.sliceSource.cutsiteSlices;
  }

  isValidCharacter(char: string): boolean {
    if (this.model.get('sequence').isOligo() && isFullUTFlexibilityEnabled()) {
      return isValidMixedBaseSequence(char);
    }
    return isValidBase(char, this.model.get('sequence').get('_sequence').baseTable());
  }

  _getBubbleOffsetClass(): string {
    return '.dna';
  }

  showInputBubble(options: ShowInputBubbleOptions): void {
    SequenceMapUtil.showInputBubble(this, options);
  }
}
SequenceLinearMap.initClass();

interface SliceItemSourceAttributes
  extends PolymerSliceItemSourceAttributes<Sequence, PolymerLinearMapState<Sequence>, SequenceMapTabState> {
  // We technically initialize with a `Slices` collection, but `makeSlices` converts it to a mapping (or array).
  cutsiteSlices: {[index: number]: Slice};
}

class SliceItemSource extends PolymerSliceItemSource<
  Sequence,
  PolymerLinearMapState<Sequence>,
  SequenceMapTabState
> {
  cutsiteSlices!: {[index: number]: Slice};
  slices!: Slices;
  debouncedUpdate!: () => void;
  debouncedSetCutsiteRange!: () => void;

  initialize(options: SliceItemSourceAttributes): void {
    super.initialize(options);
    this.slices = new Slices(); // only used by small sequencs.
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.debouncedUpdate = debounce(this.update, 1);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.debouncedSetCutsiteRange = debounce(this.setCutsiteRange, 100);
    this.cutsiteSlices = options.cutsiteSlices;

    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.mapstate.get('sequence'), 'cutswherepls', this.setCutsiteRange);
    this.listenTo(
      this.mapstate.get('sequence')._sequence(),
      'change:bases change:offset3 change:offset5',
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.update
    );
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.mapstate.get('sequence').get('_sequence'), 'change:parts', this.update);
    this.listenTo(this.mapstate.get('sequence').annotations(), 'layerChange', () => {
      this.updateAllSliceViews(MapsConstants.SliceComponentName.annotations);
    });
    this.listenTo(this.mapstate.get('sequence').sequencePrimers(), 'layerChange', () => {
      this.updateAllSliceViews(MapsConstants.SliceComponentName.forwardPrimers);
      this.updateAllSliceViews(MapsConstants.SliceComponentName.reversePrimers);
    });
    if (BenchlingConfig.PARTS_ENABLE_OVERLAPPING_PARTS) {
      this.listenTo(this.mapstate.get('sequence').parts(), 'layerChange', () => {
        this.updateAllSliceViews(MapsConstants.SliceComponentName.partAnnotations);
      });
    }
    this.listenTo(this.mapstate.get('sequence').orfs(), 'reset', () => {
      this.updateAllSliceViews(MapsConstants.SliceComponentName.orfs);
    });
    this.listenTo(this.mapstate.get('sequence').translations(), 'layerChange', () => {
      this.updateAllSliceViews(MapsConstants.SliceComponentName.translations);
    });
    this.listenTo(this.mapstate.get('sequence'), 'change:currentVersion', () => {
      this.updateAllSliceViews(MapsConstants.SliceComponentName.transcriptionArrow);
      this.updateAllSliceViews(MapsConstants.SliceComponentName.forwardTranscriptionLine);
      this.updateAllSliceViews(MapsConstants.SliceComponentName.reverseTranscriptionLine);
    });
    this.listenTo(
      this.mapstate.get('sequence')._sequence().translations(),
      'change:translationGroupId',
      () => {
        this.updateAllSliceViews(MapsConstants.SliceComponentName.translations);
      }
    );
  }

  makeSlices(): void {
    // When the cutsiteSlices are updated, we will set them on the actual slices.
    const max = this.mapstate.get('maxBases');
    const length = this.mapstate.get('sequence').length();
    const total = Math.max(1, Math.ceil(length / max)); // at least one slice.

    this.cutsiteSlices = (() => {
      if (this.mapstate.get('sequence').isReallyBig()) {
        const sliceMap: {[index: number]: Slice} = {};
        const object = this.get('scroller').indexMap;
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const i in object) {
          sliceMap[i] = new Slice();
        }
        return sliceMap;
      } else {
        // @ts-expect-error: unclear what's happening here
        this.slices.reset(__range__(0, total, false).map((idx) => ({})));
        return this.slices.models;
      }
    })();
  }

  setScroller(scroller: InfiniteScroller<SliceView>): void {
    super.setScroller(scroller);
    this.makeSlices();
    this.listenTo(scroller, 'scroll', this.debouncedSetCutsiteRange);
  }

  updateAllSliceViews(componentName: MapsConstants.SliceComponentName): void {
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression,no-restricted-syntax
    _.each(this.get('scroller').items(), (sliceView) => sliceView.updateComponent(componentName));
  }

  setCutsiteRange(): void {
    const start = this.get('scroller').firstRendered()!.item().slice.get('start');
    const end = this.get('scroller').lastRendered()!.item().slice.get('end');
    // We only have to remake if we are a big sequence.
    if (this.mapstate.get('sequence').isReallyBig()) {
      this.makeSlices();
      this.mapstate.get('sequence').trigger('cutstherepls', {start, end});
    }
  }

  extraSliceData(index: number): {cutData: Array<CutSite>} {
    return {
      cutData: this.cutsiteSlices[index] != null ? this.cutsiteSlices[index].get('cutData') : [],
    };
  }

  sliceViewY(): Array<MapsConstants.SliceComponentName> {
    const seq = this.mapstate.get('sequence');
    if (seq.isOligo()) {
      return MapsConstants.OLIGO_MAP_Y_COMPONENTS;
    } else if (seq.isRNASequence()) {
      return MapsConstants.RNA_LINEAR_MAP_Y_COMPONENTS;
    } else {
      return MapsConstants.LINEAR_MAP_Y_COMPONENTS;
    }
  }

  sliceViewZ(): Array<MapsConstants.SliceComponentName> {
    const seq = this.mapstate.get('sequence');
    if (seq.isOligo()) {
      return MapsConstants.OLIGO_MAP_Z_COMPONENTS;
    } else if (seq.isRNASequence()) {
      return MapsConstants.RNA_LINEAR_MAP_Z_COMPONENTS;
    } else {
      return MapsConstants.LINEAR_MAP_Z_COMPONENTS;
    }
  }
}

export {SequenceLinearMap as SequenceLinearMapTabView};

function __range__(left: number, right: number, inclusive: boolean): Array<number> {
  const range = [];
  const ascending = left < right;
  const end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}
